import { Component, OnInit } from '@angular/core';
import { IVTableColumn } from '@app/directives/_layout/v-table/_models/IVTableColumn';
import { IVTableRow } from '@app/directives/_layout/v-table/_models/IVTableRow';
import { VTableService } from '@app/directives/_layout/v-table/_services/v-table.service';
import { SortDirection } from '@app/enum/SortDirection';
import { NavigationService } from '@app/services/navigation.service';
import { TranslationService } from '@app/services/translation.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { finalize, tap } from 'rxjs/operators';
import { NoteType } from '../../_enums/NoteType';
import { ResourceType } from '../../_enums/ResourceType';
import { FoundationNotesService } from '../../_services/notes.service';
import { INote } from '../../_services/notes.service.ajs';
import './notes-audit-list.component.scss';

@UntilDestroy()
@Component({
    selector: 'foundation-notes-audit-list',
    template: require('./notes-audit-list.component.html')
})
export class FoundationAuditNotesListComponent implements OnInit {
    customerId: number;

    notes: INote[];
    tabCount: number = 0;
    tableColumns: IVTableColumn<INote>[];
    tableRows: IVTableRow[];

    loading: boolean;

    constructor(
        private readonly navigationService: NavigationService,
        private readonly notesService: FoundationNotesService,
        private readonly translationService: TranslationService,
        private readonly vTableService: VTableService
    ) {
    }

    ngOnInit(): void {
        this.createTable();
        this.customerId = this.navigationService.getRouteParam("customerId");
        this.getData();
    }

    // ---

    private getData(): void {
        this.loading = true;

        this.notesService.getNotes(this.customerId, ResourceType.Account, NoteType.Automatic).pipe(
            untilDestroyed(this),
            tap(notes => {
                this.notes = notes;
                this.tabCount = notes.length;
            }),
            finalize(() => {
                this.tableRows = this.vTableService.createTableRows(this.notes, this.tableColumns);
                this.loading = false;
            })
        ).subscribe()
    }

    private createTable(): void {
        this.tableColumns = [
            {
                header: this.vTableService.createDateTableHeader({ sorted: true, sortDirection: SortDirection.Descending }),
                createCellFunction: note => this.vTableService.createDateCell(note.CreatedOn)
            },
            {
                header: this.vTableService.createTableHeader({ tKey: "Common.User", width: 100, sortable: true }),
                createCellFunction: note => this.vTableService.createTableCell(this.translationService.t("Common.Unknown"))
            },
            {
                header: this.vTableService.createTableHeader({ tKey: "Common.Log", sortable: true }),
                createCellFunction: note => this.vTableService.createTableCell(note.Comments)
            }

        ]
    }
}
